import DeleteModal from "../components/DeleteModal";
import { deleteVenue } from "../clients/art";

function DeleteVenueModal(props) {
  return (
    <DeleteModal
      request={deleteVenue}
      id={props.id}
      onClose={props.onClose}
      onDelete={props.onDelete}
      toastMessage="The venue was deleted"
      title="Delete venue?"
      confirmText={props.name}
      message={
        <p className="m-0">
          Do you want to delete&nbsp;
          <span className="text-muted">{props.name}</span>
          &nbsp;permanently?
        </p>
      }
    />
  );
}

export default DeleteVenueModal;
